import { render, staticRenderFns } from "./RoomDetail.vue?vue&type=template&id=1ada10d2&scoped=true&"
import script from "./RoomDetail.vue?vue&type=script&lang=js&"
export * from "./RoomDetail.vue?vue&type=script&lang=js&"
import style0 from "./RoomDetail.vue?vue&type=style&index=0&id=1ada10d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ada10d2",
  null
  
)

export default component.exports